import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import config from '../../../config/config.json';
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Sidebar } from 'primereact/sidebar';
import { Menu } from "primereact/menu";
import { getCartCount, getAppCurrencies } from './../../../apis/requests';
import { Badge } from 'primereact/badge';
import store from "../../redux/store";
import { setCartCount } from "../../redux/reducer";
import useLang from './../../../hooks/useLang';
import { updateLang } from './../../../utils/utils';
import MobileFilters from "../../store/home/shop/MobileFilters";
import { InputText } from "primereact/inputtext";
const Header = () => {
    const { t } = useTranslation();
    const lang = useLang();
    const isRTL = lang === "ar";
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();
    const userLoggedStatus = useSelector((state) => state.app.isuserlogged);
    const [searchQuery, setSearchQuery] = useState('');
    const cartCount = useSelector((state) => state.app.cartCount);
    const [currencyItems, setCurrencyItems] = useState([]);
    const [showSidebar, setShowSidebar] = useState(false);
    const [currentCurrency, setCurrentCurrency] = useState(() => {
        try {
            const stored = localStorage.getItem('upc');
            return stored ? JSON.parse(atob(stored)) : config.defaultCurrency;
        } catch (error) {
            console.log('Invalid stored currency, falling back to default', error);
            return config.defaultCurrency;
        }
    });
    const currencyRef = useRef();

    useEffect(() => {
        loadGetCartCount();
        loadAppCurrencies();
    }, []);
    const loadAppCurrencies = async () => {
        try {
            const res = await getAppCurrencies();
            let currencies = res.data.currencies.map((c) => {
                return {
                    label: c.title,
                    command: () => {
                        localStorage.setItem('upc', btoa(JSON.stringify(c)));
                        window.location.reload();
                    }
                }
            });
            setCurrencyItems(currencies);
        } catch (error) {
            console.log(error);
        }
    }

    const loadGetCartCount = async () => {
        try {
            let params = {
                cart_id: localStorage.getItem('cart'),
            }
            const res = await getCartCount(params);
            store.dispatch(setCartCount(res.data.cartCount))
        } catch (error) {
            console.log(error);
        }
    }

    const isActive = (path) => location.pathname === path;

    return (
        <section className="fixed w-full shadow-md header overflow-x-hidden" dir={isRTL ? "rtl" : "ltr"}>
            <Sidebar
                visible={showSidebar}
                onHide={() => setShowSidebar(false)}
                position={isRTL ? "right" : "left"}
            >
                <MobileFilters filterId={params.id} filterType={params.type}
                    onClose={() => setShowSidebar(false)}
                />
            </Sidebar>
            <div className="hidden md:block lg:block">
                <nav className="flex justify-center p-3"
                    style={{ backgroundColor: config.home_header_section_bg }}
                >
                    <div className="grid grid-cols-12 items-center gap-2 w-full max-w-full">
                        <div className="col-span-4">
                            <Menu
                                model={currencyItems}
                                popup
                                ref={currencyRef}
                                onBlur={(e) => {
                                    e.preventDefault();
                                    currencyRef.current.hide(e);
                                }}
                            />
                            <div className="right">
                                <div className="header-logo flex items-center">
                                    <button
                                        type="button"
                                        aria-label={t('change_currency') || 'Change currency'}
                                        onClick={(e) => currencyRef.current.toggle(e)}
                                        className="mx-1 hidden lg:block"
                                    >
                                        <img src={currentCurrency.image} alt={currentCurrency.title || 'currency'} className="w-10 mt-2 mx-3" />
                                    </button>
                                    <div className="mx-2">
                                        <img src={config.header_logo} alt={config.APP_NAME} className="max-w-full max-h-[50px]" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-span-6">
                            <div className="mx-3 flex search_bar">
                                <InputText className="search_input"
                                    style={{
                                        backgroundColor: config.home_header_section_bg,
                                        paddingRight: '2.5rem',
                                        height: 45,
                                        width: '100%'
                                    }}
                                    value={searchQuery}
                                    onChange={(e) => {
                                        setSearchQuery(e.target.value);
                                    }}
                                />
                                <button className="cursor-pointer"
                                    onClick={() => {
                                        if (searchQuery.length > 0) {
                                            navigate('/shop/search/' + searchQuery);
                                        } else {
                                            navigate('/shop');
                                        }

                                    }}
                                >
                                    <span className="material-symbols-outlined header-search-icon">
                                        search
                                    </span>
                                </button>
                            </div>

                        </div>
                        <div className="col-span-2">
                            <div>
                                <ul className="top-header-links flex items-center justify-end">
                                    <li>
                                        <Link to={userLoggedStatus ? '/dashboard/wishlist' : '/login'}
                                            aria-label={t('wishlist') || 'Wishlist'}
                                            className="font-semibold text-2xl">
                                            <span className="material-symbols-outlined">favorite</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link
                                            to={userLoggedStatus ? '/dashboard/account' : '/login'}
                                            aria-label={t('account') || 'Account'}
                                            className="font-semibold text-2xl">
                                            <span className="material-symbols-outlined">account_circle</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/cart" aria-label={t('cart') || 'Cart'} className="font-semibold text-2xl">
                                            <div>
                                                <span className="material-symbols-outlined p-overlay-badge">
                                                    shopping_bag
                                                    {cartCount > 0 && <Badge value={cartCount} />}
                                                </span>
                                            </div>
                                        </Link>
                                    </li>
                                    <li>
                                        <button
                                            type="button"
                                            onClick={() => updateLang(lang)}
                                            className="font-semibold mx-2"
                                        >
                                            {lang === "en" ? "العربية" : "English"}
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/* <div className="col-span-1"></div> */}
                    </div>
                </nav>
                <nav className="flex items-center justify-between flex-wrap p-4"
                    style={{ backgroundColor: config.home_sub_header_section_bg, color: "#FFF" }}
                >
                    <div className="w-full block flex-grow lg:flex lg:items-center lg:w-auto">
                        <div className="flex-grow flex items-center justify-center flex-wrap">
                            <button
                                type="button"
                                aria-label={t('open_menu') || 'Open menu'}
                                className="mt-2 lg:hidden"
                                onClick={() => setShowSidebar(true)}
                            >
                                <span className="material-symbols-outlined" style={{ fontSize: 30, color: "#FFF" }}>menu</span>
                            </button>
                            {[
                                { to: '/', label: 'home' },
                                { to: '/shop', label: 'shop' },
                                { to: '/categories', label: 'categories' },
                                { to: '/brands', label: 'brands' },
                                { to: '/collections', label: 'collections' },
                                { to: '/shop/latest', label: 'latest' },
                                { to: '/shop/top-rated', label: 'top_rated' },
                                { to: '/shop/top-selling', label: 'best_sellers' },
                            ].map((link) => (
                                <Link
                                    key={link.to}
                                    to={link.to}
                                    className="font-semibold mx-2"
                                >
                                    {t(link.label)}
                                </Link>
                            ))}
                        </div>
                    </div>
                </nav>
            </div>

            <div className="md:hidden lg:hidden">
                <nav className="py-3" style={{ backgroundColor: config.home_header_section_bg }}>
                    <div className="flex items-center justify-between">
                        <div className="flex items-center">
                            {
                                location.pathname !== "/" &&
                                <button
                                    type="button"
                                    aria-label={t('go_back') || 'Go back'}
                                    className=""
                                    onClick={() => navigate(-1)}
                                >
                                    <span className="material-symbols-outlined" style={{ fontSize: 40, color: "#004040" }}>
                                        {isRTL ? 'arrow_right_alt' : 'arrow_left_alt'}
                                    </span>
                                </button>
                            }
                            <img src={config.header_mobile} alt={config.APP_NAME} className="mx-2 w-40 max-h-[50px]" />
                        </div>
                        <div>
                            <ul className="top-header-links flex items-center">
                                {/* <li>
                                    <Link
                                        to={userLoggedStatus ? '/dashboard/account' : '/login'}
                                        aria-label={t('account') || 'Account'}
                                        className="font-semibold text-2xl">
                                        <span className="material-symbols-outlined text-[#004040]">account_circle</span>
                                    </Link>
                                </li> */}
                                <li>
                                    <Link to="/cart" aria-label={t('cart') || 'Cart'} className="font-semibold text-2xl">
                                        <div>
                                            <span className="material-symbols-outlined p-overlay-badge text-[#004040]">
                                                shopping_bag
                                                {cartCount > 0 && <Badge value={cartCount} />}
                                            </span>
                                        </div>
                                    </Link>
                                </li>
                                <li>
                                    <button
                                        type="button"
                                        aria-label={t('open_menu') || 'Open menu'}
                                        onClick={() => setShowSidebar(true)}
                                    >
                                        <span className="material-symbols-outlined" style={{ fontSize: 30, color: "#004040" }}>menu</span>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
            </div>
        </section>
    );
}
export default Header;